// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --red: #E41116;
  --white: #ffffff;
  --black: #161513
}

body {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
  overflow-x: hidden;
  font-family: "Roboto";
  background-color: #F1F1F1 !important;
}

/* Latest css update for fonts */
p.paragraph {
  color: var(--black);
  font-size: 1rem;
}

label {
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1rem;
  letter-spacing: 0em;
}

.continueGoogle {
  background-color: #B1C5E7;
  color: #ffff;
  font-family: "Roboto";
  height: 3.2rem;
  text-align: center;
}

header {
  z-index: 99 !important;
}

@media (max-width:600px) {
  .xs-mb-2 {
    margin-bottom: 0.5rem;
  }
}

.fs-35 {
  font-size: 35px;
}

.fs-09 {
  font-size: 0.9rem
}

.fs-08 {
  font-size: 0.8rem
}

.fw-400 {
  font-weight: 400 !important;
}

.font-roboto-slab {
  font-family: Roboto Slab;
}

.cardBtn {
  background-color: #E1E6F4 !important;
}

.paymentCart {
  background-color: #F2EDED;
}

.signProfile {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
}

.checkbox {
  height: 25px;
  width: 25px;
}

.profileCheckbox {
  border: 2px solid #B1C5E7 !important;
}

.user-image {
  height: 2rem;
  width: 2rem;
  border-radius: 50%;
}

.listItem {
  transition: .5s;
  color: white !important;
  font-weight: 500;
}

.listItem:hover {
  transition: .5s;
  color: red !important;
  border: transparent;
  border-radius: 3rem !important;
  background-color: white !important;
}

.listItem>a:hover {

  color: red !important;

}

.categoryCard {
  height: 21.7rem;
}

.btnIcon {
  position: relative;
  box-shadow: 0 0 40px rgba(51, 51, 51, .1)
}

.btnIcon input {
  height: 60px;
  text-indent: 25px;
  border: 2px solid #d6d4d4
}

.btnIcon input:focus {
  box-shadow: none;
  border: 2px solid blue
}

/* .footerBg{
background: rgba(0, 0, 0, 0.2);
} */
.serviceCard {
  border-radius: 3rem;
}

footer {
  background-color: #d8d8d8;
  opacity: 1;
  height: 40px;
  bottom: 0;
  width: 100%;
}

.orderSummary {
  background-color: rgba(196, 196, 196, 0.2);
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  height: 395px;
}

.ms-n5 {
  margin-left: -49px;
  margin-top: 6px;
}

.searchBtn {
  height: 50px;
  background-color: #ECEFF9 !important;
  border-radius: 8px !important;
  height: 2.8rem;
}

.Btn {
  width: 22rem !important;
}

.sortBtn {
  width: 10rem !important;
  border: 2px;
}

.chat {
  background-color: #e6e6e6;
  border-radius: 40px 10px 10px 10px;
}

.user-img {
  height: 70px;
  width: 70px;
}

.chatBox {
  height: 60rem;
}

.avatar img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -15px;
  z-index: 1;
}

.imgSize {
  height: 30px;
  width: 30px;
}

.avatars {
  direction: rtl;
  padding-left: 25px;
  /* Same value as the negative margin */
}

._1EEDX:focus {
  outline: none !important;
  border: none !important;
}

._3sXmF:hover {
  background: none !important;
}

.selectedType>div>div {
  padding: 0px;
}

/* fieldset{
  border: none !important;
} */
.form-input input {
  display: none;
}

.form-input label {
  display: block;
  cursor: pointer;
}

.cursorGrab {
  cursor: grab;
}

.imageOpacity {
  opacity: 1;
  transition: .5s ease;
  backface-visibility: hidden;
}

.containerImage:hover .imageOpacity {
  opacity: 0.3;
}

.h-55vh {
  height: 55vh;
}

.apply {
  right: 7px;
  ;
}

.content-wrapper {
  height: 96vh;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}

.active {
  color: var(--red);
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}

/* CSS added on -> 24-11-2022:Vibhav */

/* Define new buttons styles */
.gn-actionbtn-color {
  color: #F14950 !important;
}

.gn-actionbtn-outline {
  border: 1px solid #F14950 !important;
  border-radius: 10px !important;
}

.gn-actionbtn {
  background-color: #F14950 !important;
  border: 1px solid #F14950 !important;
  border-radius: 10px !important;
  box-sizing: border-box;
  padding: 10px;
  gap: 10px;
  color: #fff !important;
  box-shadow: 0px 4px 8px -4px #4C4E646B;
}

.disablebtn {
  border: 1px solid;
  border-radius: 4px;
  padding: 10px 24px;
  color: #b9b9b9;
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */

}

.gn-actionbtn:hover {
  transition: all 0.2s ease-in;
  scale: 1.05;
}

.gn-actionbtn.outlined,
.gn-actionbtnsq.outlined {
  background-color: transparent;
  color: #E41116
}

.gn-actionbtn.outlined.dark,
.gn-actionbtnsq.outlined.dark {
  background-color: transparent;
  color: #161513;
  border-color: #161513;
  font-weight: 500;
}

.gn-actionbtnsq {
  padding: 6.5px;
  border-radius: 4px;
  border: 1px solid #E41116;
}

.gn-actionbtncircle {
  width: 2.5rem !important;
  height: 2.5rem !important;
  border-radius: 50% !important;
  box-shadow: 0px 0px 10px 2px #00000045;
  border: solid 1px var(--red);
}

.gn-actionbtncircle.solid {
  color: var(--white);
  background-color: var(--red);
}

.gn-actionbtncircle.outlined {
  color: var(--red);
  background-color: var(--white);
}

.icononly-btn {
  display: flex;
  justify-content: flex-end;
  padding: 0px;
  margin: 0px;
  border: none;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  text-align: center;
  cursor: pointer;
  display: block;
  background: none;
  appearance: none;
  box-sizing: border-box;
  vertical-align: middle;
}

.gn-btn-icononly {
  background: transparent;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  border: none;
}

/*To hide the clear icon in mui component autocomplete select component language page*/
.css-1q60rmi-MuiAutocomplete-endAdornment {
  display: none;
}

/* Override the link css */
a {
  color: #2979BC
}

a:hover {
  color: #2979BC
}

a.nav-list-items {
  text-decoration: none;
}

/* Override bootstrap css to make links responsive:06-12-2022 */
@media only screen and (max-width: 1280px) and (min-width: 1100px) {
  .creator-links.col-xl-5 {
    width: 60% !important;
  }
}

@media (max-width:500px) {

  .container-fluid.creator-link-panel,
  .container-fluid.creator-playlist-panel {
    margin: 0px;
    padding: 0px
  }

  .pic-holder {
    width: 50px !important;
    height: 50px !important;
  }

  .card-container {
    padding: 0px !important;
  }

  .link-details {
    padding: 10px 0px !important
  }
}

/* CSS for new profile design:07-12-2022 */
.main-profile-container {
  flex-wrap: wrap
}

.profile-tabs {
  width: 20%;
}

.probile-tab-content {
  width: 80%
}

@media only screen and (max-width: 1100px) {
  .profile-tabs {
    width: 100%;
  }

  .probile-tab-content {
    width: 100%
  }
}

a button {
  opacity: 1 !important;
  font-size: 1.25rem !important;
  text-transform: capitalize !important;
}

.account-bg {
  background: rgba(249, 249, 249, 0.3);
}

@-moz-document url-prefix() {

  html,
  .scroll-element .MuiDrawer-paper {
    overflow-y: scroll;
    scrollbar-color: #E41116 rgb(231, 229, 229);
    box-shadow: inset 0 0 5px rgb(231, 229, 229);
    border-radius: 10px;
    scrollbar-width: thin;
  }
}

/* For Firefox */
/* Set the scrollbar width */

/*Scroll bar styling*/
/* html::-webkit-scrollbar,
body::-webkit-scrollbar,
.scroll-element .MuiDrawer-paper */
::-webkit-scrollbar {
  -moz-width: 0.3rem;
  -moz-height: 0.3rem;
  width: 0.3rem;
  height: 0.3rem;
}

/* html::-webkit-scrollbar-track,
body::-webkit-scrollbar-track,
.scroll-element.MuiDrawer-paper */
::-webkit-scrollbar-track {
  -moz-box-shadow: inset 0 0 5px grey;
  -moz-border-radius: 10px;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* html::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-thumb,
.scroll-element.MuiDrawer-paper */
::-webkit-scrollbar-thumb {
  -moz-background-color: #E41116;
  background-color: #E41116;
}


.element-with-scroll {
  overflow-y: scroll;
  max-height: 100px;
  /* Set a maximum height for the scrollable element */
}



/* Styling the scrollbar in Firefox  */
.element-with-scroll {
  scrollbar-color: red green;
  scrollbar-width: thin;
}

.removeBorder .MuiInputBase-root::before {
  border-bottom: 0px !important
}

.gn-actionbtn:disabled {
  opacity: 0.5;
}

/* css for the verification page column */
.verifyCol1 {
  width: calc(40% - 20px);
}

.verifyCol2 {
  width: calc(60% - 20px);
}

#artist-avatar {
  width: 30%
}

#artist-status {
  width: 70%
}

.column-1 {
  width: 30%
}

.column-2 {
  width: 65%
}

@media (min-width:1281px) and (max-width:1550px) {

  /* For portrait layouts only */
  #artist-avatar {
    width: 35%
  }

  #artist-status {
    width: 65%
  }

  .column-1 {
    width: 40%
  }

  .column-2 {
    width: 55%
  }
}

@media (max-width:1280px) {
  .verifyCol1 {
    width: 100%
  }

  .verifyCol2 {
    width: 100%
  }

  .column-1 {
    width: 100% !important
  }

  .column-2 {
    width: 100% !important
  }
}

@media (max-width:768px) {
  #artist-avatar {
    width: 100%
  }

  #artist-status {
    width: 100%
  }
}

/*switcher styles*/
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 19px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  box-shadow: inset 0px 4px 4px #00000042;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: .4s;
  box-shadow: 2px 2px 2px #33333375;
}

input:checked+.slider {
  background-color: #B1C5E7;
  box-shadow: inset 0px 4px 4px #96a9cb;
}

input:disabled+.slider {
  background-color: none;
  box-shadow: inset 0px 4px 4px #96a9cb;
  opacity: 0.4;
}

/* input:focus + .slider { */
/*  box-shadow: inset 0 0 1px #B1C5E7; */
/*  box-shadow: inset 0px 4px 4px #96a9cb; */
/* } */

input:checked+.slider:before {
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* Css for verification badge */
.item {
  position: relative;
  padding-top: 20px;
  display: inline-block;
}

.notify-badge {
  position: absolute;
  right: -9px;
  text-align: center;
  border-radius: 30px 30px 30px 30px;
  color: white;
  padding: 5px 10px;
  font-size: 20px;
  bottom: -1px;
}

/* Design for small screens less than - 768px */
@media (max-width:1024px) {

  body,
  body>div,
  body>p,
  .link-input-fields div,
  a button {
    font-size: 0.8rem !important;
  }

  /* for button */
  .gn-actionbtn {
    padding: 6px 18px !important;
  }

  .link-wrapper {
    width: 78% !important
  }

  .profile-wrapper {
    width: 22% !important;
  }

  .switch {
    width: 26px !important;
    height: 14px !important;
  }

  input:checked+.slider:before {
    left: -2px !important
  }

  .slider:before {
    width: 10px !important;
    height: 10px !important;
    left: -2px !important;
    left: 1px !important
  }
}

/* .MuiTooltip-popper[data-popper-placement*="bottom"] .css-1k51tf5-MuiTooltip-tooltip {
  transform-origin: center top;
  margin-top: 0px !important;
} */
/* CSS to override the style of mui buttons */
/* .iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root,.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root{
    max-width: 40px !important;
    min-width: 40px!important;
    min-height: 40px!important;
    max-height: 40px!important;
}

.iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root, .iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root:hover{border-color:#E41116;color:#E41116}
.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root,.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root:hover{ background-color:#E41116;}

 */
.custom-tooltip {
  padding: 4px 10px;
  background: #e41116;
  font-size: 0.8rem;
  margin: 0;
  border-radius: 4px;
  position: relative;
  color: white;
  bottom: -5px;
  left: 0;
  max-width: 200px;
  text-align: center;
}

.custom-tooltip.auto-width {
  max-width: 200px !important;
}


.custom-tooltip .top::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #E41116 transparent;
}

/* format the placeholder text for react edit text fields */
.link-input-fields ._1EEDX {
  padding: 5px 0px !important
}

.link-input-fields ._3qwMT {
  color: #b1adad;
  font-weight: 400;
}

.css-18k588b-MuiAutocomplete-root {
  padding: 5px 0px !important
}

/* CSS for social card */
.social-link-container {
  padding: 15px;
  max-height: 400px;
  overflow-y: auto;
}

.social-link-container .action-btn-container {
  margin-right: 0 !important
}

@media (max-width: 768px) {
  .social-link-container .link-wrapper {
    width: 95% !important;
  }

  .social-link-container .action-btn-container {
    margin-right: 0 !important
  }
}

/* New change */

.avatar-upload {
  position: relative;
  max-width: 180px;
  /* margin: 20px auto; */
}

.avatar-upload .avatar-edit {
  position: absolute;
  /* right: 12px; */
  /* z-index: 1; */
  /* top: 10px; */
  right: 45px;
  z-index: 1;
  top: 1px;
  border-radius: 100%;
}

.avatar-upload .avatar-edit input {
  display: none;
}

.avatar-upload .avatar-edit input+label {
  display: inline-flex;
  width: 34px;
  height: 34px;
  /* width: 20px;
  height: 20px; */
  margin-bottom: 0;
  border-radius: 100%;
  background: #FFFFFF;
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  font-weight: normal;
  transition: all 0.2s ease-in-out;
  align-items: center;
  justify-content: center;
}

.avatar-upload .avatar-edit input+label:hover {
  background: #f1f1f1;
  border-color: #d6d6d6;
}

/* .avatar-upload .avatar-edit input + label:after {
  content: "\\f040";
  font-family: 'FontAwesome';
  color: #757575;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
} */
.avatar-upload .avatar-preview {
  /* width: 192px;
  height: 192px; */
  position: relative;
  border-radius: 100%;
  /* border: 6px solid #F8F8F8; */
  /* box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1); */
}

.avatar-upload .avatar-preview>div {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/*singup thank you page*/
.fullPage>.fullpage-content {
  position: absolute;
  left: calc(100% - 87%);
  top: calc(100% - 87%);
  transition: all 0.5s ease-in;
}

.fullPage .fullpage-inner-content {
  position: relative;
  left: 17%;
  transition: all 0.5s ease-in;
}

.emailVerification>.fullpage-content {
  position: absolute;
  width: 100%;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
  transition: all 0.5s ease-in;
}

.fullpage-logo>img {
  width: 300px;
  transition: width 0.5s ease-in;
}

.fullpage-logo {
  padding: 0.5rem
}

@media (max-width:767px) {
  .fullPage>.fullpage-content {
    position: absolute;
    left: 1%;
    top: 15%;
    transition: all 0.5s ease-in;
  }

  .emailVerification>.fullpage-content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    transition: all 0.5s ease-in;
  }

  .fullPage .fullpage-inner-content {
    position: relative;
    left: 0%;
    transition: all 0.5s ease-in;
    padding: 0.5rem;
  }

  .fullPage>.fullpage-content>img,
  .emailVerification>.fullpage-content>img {
    width: 70%;
    transition: all 0.5s ease-in;
  }

  .fullpage-logo>img {
    width: 30%;
    transition: width 0.5s ease-in;
  }
}

@media (min-width:768px) and (max-width:1280px) {
  .fullPage>.fullpage-content {
    position: absolute;
    left: 5%;
    top: 13%;
    transition: all 0.5s ease-in;
  }

  .fullPage .fullpage-inner-content {
    position: relative;
    width: 80%;
    left: 11%;
    transition: all 0.5s ease-in;
  }

  .fullPage>.fullpage-content>img {
    width: 70%;
    transition: all 0.5s ease-in;
  }

  .fullpage-logo>img {
    width: 180px;
    transition: width 0.5s ease-in;
  }

}

.pagination {
  width: 100%;
}

.tableSelector {
  color: var(--selectorColor) !important;
}

.tableSelector.Mui-checked,
.tableSelector.MuiCheckbox-indeterminate {
  color: var(--selectedColor) !important;
}

.MuiTablePagination-displayedRows {
  /* padding: 14px 0px 10px !important; */
  margin-top: 14px;
}

.MuiTablePagination-selectLabel {
  margin-top: 14px;
}

/* .css-1jamkpd-MuiToolbar-root {
    min-height: 10px !important;
} */
.css-1fjhhui-MuiToolbar-root {
  min-height: 10px !important;


}

.css-1tw8r9a-MuiToolbar-root {
  min-height: 10px !important;

}

/* Latest css by tanya for submit a song--- */

/* .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root{
  height: 1.5em !important;
  width: 1.5em !important;
} */
/* .css-i4bv87-MuiSvgIcon-root{
  width: 2em !important;
} */


.cardheading {
  font-size: 1.5rem;
  font-weight: 500;
  color: #222222b5;
}

.status {
  border: 1px;
  border-radius: 15px;
  padding: 2px 10px;
  width: -moz-fit-content;
  width: fit-content;
  text-align: center;
  font-size: 12px;
}

.audio-uploader {
  border: 2px dashed rgba(0, 0, 0, 0.5);
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
  background: #EAEAEA;
  height: 200px;
  cursor: pointer;
}

.audio-uploader.custom-height {
  height: 150px;
}

.audio-uploader input[type='file'] {
  display: none;
}

.audio-uploader .dragInputText {
  color: rgba(0, 0, 0, 0.6);
  font-size: 1.2rem;
  font-weight: bold;
  margin-left: 0.8rem;
  padding: 0.6rem 0rem;
}

.audio-uploader .dropImage {
  opacity: 0.3;
}

.songPoster {
  border-radius: 20px;
  max-width: 280px;
  max-height: 280px;
}

.poster-uploader {
  text-align: center;
}

#removeSongPoster {
  display: flex;
  justify-content: end;
}

audio.gn-audioplayer {
  width: 100%;
  height: 60px;
}

.box {
  width: 60%;
  max-width: 1024px;
  margin: 0 auto;
  /* center the box horizontally */
  transition: width 0.5s ease-in;
}

#addsong-stepper-container #songposter-helpertext {
  padding: 1.2rem 1rem;
}

.value-pair {
  padding: 0.4rem 0rem
}

@media (max-width:500px) {
  #song-poster-cnt {
    width: 100%
  }

  .songPoster {
    max-width: 100%;
    max-height: 100%;
    width: 100%
  }
}

@media (min-width:501px) and (max-width:1280px) {
  #song-poster-cnt {
    width: 40%
  }

  .songPoster {
    max-width: 200px;
    max-height: 200px;
  }
}

@media (max-width: 768px) {
  .box {
    width: 100%;
  }
}

/* @media (min-width: 769px) and(max-width:1280px)
{
  .songPoster{width: 100%;max-width: 200px;max-height: 200px;}
  #song-poster-cnt{width:30%}
} */
@media (min-width: 769px) and (max-width: 1500px) {
  .box {
    width: 90%;
  }
}

@media (min-width: 1501px) and (max-width: 1800px) {
  .box {
    width: 70%;
  }
}

/*End*/
/* Css by Tanya - responsive card list on mobile */
/* mobileCard css */
/* start */
/* .mobileCard{
  width: fit-content;
  text-align: center;
} */
.cardLine {
  line-height: 0.8;
}

.cardheadingFont {
  font-size: 0.8rem;
}

.cardfont {
  font-size: 0.6rem
}

.overflow-text {
  white-space: nowrap;
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.css-78trlr-MuiButtonBase-root-MuiIconButton-root {
  /* width:1rem; */
  /* height:1rem; */
  border-radius: 4px;
}

.playBtn {
  /* border: 1px solid #E41116; */
  border: 1px solid red;
  border-radius: 4px;

}

.audioBorder {
  border: 1px solid;
  border-radius: 5px;
  width: 100%;


}

.boxSize {
  /* marginLeft:'30%',width:'40%' */
  margin-left: '30%';
  width: '40%';
}

.css-2s90m6-MuiAvatar-root {
  width: 30px !important;
  height: 30px !important;
}

.class-name:after {
  content: " ";
  display: block;
  border-bottom: 0.5px solid #9E9E9E;
}

.form-check-input[type=checkbox] {
  border-radius: 0%;
}

#imagePreview {
  width: 200px;
  /* height: 200px; */
  height: auto
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  /* Optional: Limit the width of the container */
}

.truncate-text:hover {
  white-space: normal;
  overflow: visible;
}

/* .css-78trlr-MuiButtonBase-root-MuiIconButton-root */
/* end */

.tempSection {
  position: absolute;
  z-index: 2;
  width: 100%;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  text-align: center;
}

.associatedArtistCardLayout {
  display: flex;
  flex-wrap: wrap;
  /* gap: 10px;  */
}

@media (max-width: 600px) {
  .MuiTablePagination-toolbar {
    padding: 0px !important
  }

  .smallAssociatedArtistCard {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: calc(50% - 10px);
    /* Reduce the card's max width for small screens */
    transform: scale(0.8);
    /* Apply scaling for small screens */
    transform-origin: left;
  }

  .cardPagination {
    font-size: 0.8rem !important
  }

  .css-16c50h-MuiInputBase-root-MuiTablePagination-select {
    margin-right: 0.8rem !important
  }
}

@media (max-width: 280px) {
  .smallAssociatedArtistCard {
    flex: 1 1 100%;
    /* 1 card per row on devices with a width of 280px or less */
    max-width: 100%;
    /* Set the card's max width to 100% for single card layout */
    transform: none;
    /* Reset scaling for very small screens */
  }
}

.notificationItem:hover {
  background-color: rgb(247, 246, 246);
  cursor: pointer;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  /* Adjust the background color as needed */
  z-index: 1000;
  /* Ensure it's above other content */
  transition: box-shadow 0.3s ease;
  /* Add a smooth transition effect for the box shadow */
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.css-6hp17o-MuiList-root-MuiMenu-list {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

/* buttonStyles.css */

/* Base button styles */
.pagination-button {
  border-radius: 4px;
  width: 100%;
  padding: 4px 0px;
  font-weight: bold;
}

/* Enabled button styles */
.pagination-button.enabled {
  color: red;
  border: 1px solid #E41116;
  background-color: #fff;
}

/* Disabled button styles */
.pagination-button.disabled {
  color: gray;
  border: 1px solid #3A3A3A;
  background-color: #fff;
  opacity: 0.5;
}

.card-container {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  justify-content: center;
}

@media (max-width: 599px) {
  .card-container {
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  }
}

@media (max-width: 280px) {
  .card-container {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
}

.wrapper-card {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  padding: 20px 0;
}

.box-card {
  border-radius: 16px;
  background: #FFF;
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.10);
  border-radius: 3px;
  padding: 10px;
  font-size: 14px;
  max-width: 330px;
  min-width: 200px;
}

.card-media {
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.28) 63.54%, #000 96.02%), lightgray 50% / cover no-repeat;
}

.artistDetailStyle {
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 20px;
  background-color: #f0f0f0;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  margin-right: 10px;
  margin-top: 10px;
  font-weight: 400;
  text-align: center;
  display: inline-block;
}

.css-1c7htm4-MuiList-root.left-margin {
  margin-left: 10rem;
}

.titlea {
  /* width: 90%; */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  min-width: 100px;
  line-height: 1.2;
  margin-bottom: 0px;
}

.externallinkicon {
  width: '50px';
  height: '50px';
  border-radius: '50%';
  background: '#E41116';
  display: 'flex';
  align-items: 'center';
  justify-content: 'center';
  margin-right: '8px';
}

@media (max-width: 600px) {
  .mobile-buttons {
    flex-direction: column;
    /* Display buttons in a column on mobile screens */
  }
}

.demodetailCol2 {
  width: calc(60% - 20px);
}

/* ---------------- suman css start ----------- */
.text-truncate-sm {
  width: 100px;
  text-overflow: ellipsis;
  text-wrap: nowrap;
  overflow: hidden;
}

.detailText::first-letter {
  text-transform: capitalize;
}

.wordBreak {
  word-break: break-all;
}

.color-secondory {
  color: rgba(0, 0, 0, 0.8);
  opacity: 90%;
}

.circle-spinner-container {
  top: 7px;
  left: 7.4px;
}

.fileDragDrop {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0;
  cursor: pointer;
}

.cursorPointer {
  cursor: pointer;
}

.height30vh {
  height: 30vh;
}

@media (max-width:330px) {
  .mediaMusic {
    flex-direction: column;
  }
}

.special-label.special-label::after {
  content: ' *';
}

.hide-div {
  display: none;
}

.imageRadio span>input {
  position: relative;
}

.radioButtonBanner>input {
  position: absolute;
  top: 8;
  right: 8;
  background-color: 'rgba(255, 255, 255, 0.7)';
  border-radius: '20px';
  width: '6%';
  height: '16%';
}

.chipStyle {
  background: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff !important;
  font-size: 12px !important;
  height: 25px !important;
}
.blurred-disabled {
  /* filter: blur(2px); */
  pointer-events: none;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;;AAEvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;;GAEG;AACH;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;;GAEG;AACH;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA,sCAAsC;;AAEtC,8BAA8B;AAC9B;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iDAAiD;;AAEnD;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,6BAA6B;EAC7B;AACF;;AAEA;;EAEE,6BAA6B;EAC7B,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,YAAY;AACd;;AAEA,sFAAsF;AACtF;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+DAA+D;AAC/D;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;;EAEE;;IAEE,WAAW;IACX;EACF;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE;EACF;AACF;;AAEA,0CAA0C;AAC1C;EACE;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE;EACF;AACF;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,2CAA2C;IAC3C,4CAA4C;IAC5C,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA,gBAAgB;AAChB,4BAA4B;;AAE5B,qBAAqB;AACrB;;kCAEkC;AAClC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;AAChB;;AAEA;;iCAEiC;AACjC;EACE,mCAAmC;EACnC,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;iCAEiC;AACjC;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oDAAoD;AACtD;;;;AAIA,sCAAsC;AACtC;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,8BAA8B;EAC9B;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EAEtB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,YAAY;AACd;;AAEA,4BAA4B;AAC5B,wCAAwC;AACxC,4CAA4C;AAC5C,MAAM;;AAEN;EAGE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA,+CAA+C;AAC/C;;EAEE;;;;;IAKE,4BAA4B;EAC9B;;EAEA,eAAe;EACf;IACE,4BAA4B;EAC9B;;EAEA;IACE;EACF;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE;EACF;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB;EACF;AACF;;AAEA;;;GAGG;AACH,6CAA6C;AAC7C;;;;;;;;;;EAUE;AACF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,2DAA2D;AAC3D;EACE;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE;EACF;AACF;;AAEA,eAAe;;AAEf;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ;iBACe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,+CAA+C;EAC/C,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;;;;;;;GAUG;AACH;EACE;kBACgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;;IAEE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,YAAY;IACZ,8BAA8B;EAChC;;AAEF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;GAEG;AACH;EACE,2BAA2B;;;AAG7B;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA,6CAA6C;;AAE7C;;;GAGG;AACH;;GAEG;;;AAGH;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uBAAkB;EAAlB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;;GAIG;AACH;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,MAAM;AACN,kDAAkD;AAClD,mBAAmB;AACnB,UAAU;AACV;;;GAGG;AACH;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;;AAEpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;;;AAGb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD,QAAQ;;AAER;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE;EACF;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;IAC3B,kDAAkD;IAClD,qBAAqB;IACrB,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE;EACF;;EAEA;IACE;EACF;AACF;;AAEA;EACE;IACE,cAAc;IACd,4DAA4D;IAC5D,eAAe;IACf,4DAA4D;IAC5D,eAAe;IACf,yCAAyC;EAC3C;AACF;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,0CAA0C;EAC1C,aAAa;EACb,oCAAoC;EACpC,gCAAgC;EAChC,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,qBAAqB;;AAErB,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,uBAAuB;AACzB;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6GAA6G;AAC/G;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,kDAAkD;EACpD;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iDAAiD;AACjD;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,4CAA4C;EAC5C,qBAAqB;EACrB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,oGAAoG;EACpG,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd","sourcesContent":[":root {\n  --red: #E41116;\n  --white: #ffffff;\n  --black: #161513\n}\n\nbody {\n  margin: 0px;\n  padding: 0px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  font-family: \"Roboto\";\n  background-color: #F1F1F1 !important;\n}\n\n/* Latest css update for fonts */\np.paragraph {\n  color: var(--black);\n  font-size: 1rem;\n}\n\nlabel {\n  font-size: 0.9rem;\n  font-weight: 400;\n  line-height: 1rem;\n  letter-spacing: 0em;\n}\n\n.continueGoogle {\n  background-color: #B1C5E7;\n  color: #ffff;\n  font-family: \"Roboto\";\n  height: 3.2rem;\n  text-align: center;\n}\n\nheader {\n  z-index: 99 !important;\n}\n\n@media (max-width:600px) {\n  .xs-mb-2 {\n    margin-bottom: 0.5rem;\n  }\n}\n\n.fs-35 {\n  font-size: 35px;\n}\n\n.fs-09 {\n  font-size: 0.9rem\n}\n\n.fs-08 {\n  font-size: 0.8rem\n}\n\n.fw-400 {\n  font-weight: 400 !important;\n}\n\n.font-roboto-slab {\n  font-family: Roboto Slab;\n}\n\n.cardBtn {\n  background-color: #E1E6F4 !important;\n}\n\n.paymentCart {\n  background-color: #F2EDED;\n}\n\n.signProfile {\n  height: 2rem;\n  width: 2rem;\n  border-radius: 50%;\n}\n\n.checkbox {\n  height: 25px;\n  width: 25px;\n}\n\n.profileCheckbox {\n  border: 2px solid #B1C5E7 !important;\n}\n\n.user-image {\n  height: 2rem;\n  width: 2rem;\n  border-radius: 50%;\n}\n\n.listItem {\n  transition: .5s;\n  color: white !important;\n  font-weight: 500;\n}\n\n.listItem:hover {\n  transition: .5s;\n  color: red !important;\n  border: transparent;\n  border-radius: 3rem !important;\n  background-color: white !important;\n}\n\n.listItem>a:hover {\n\n  color: red !important;\n\n}\n\n.categoryCard {\n  height: 21.7rem;\n}\n\n.btnIcon {\n  position: relative;\n  box-shadow: 0 0 40px rgba(51, 51, 51, .1)\n}\n\n.btnIcon input {\n  height: 60px;\n  text-indent: 25px;\n  border: 2px solid #d6d4d4\n}\n\n.btnIcon input:focus {\n  box-shadow: none;\n  border: 2px solid blue\n}\n\n/* .footerBg{\nbackground: rgba(0, 0, 0, 0.2);\n} */\n.serviceCard {\n  border-radius: 3rem;\n}\n\nfooter {\n  background-color: #d8d8d8;\n  opacity: 1;\n  height: 40px;\n  bottom: 0;\n  width: 100%;\n}\n\n.orderSummary {\n  background-color: rgba(196, 196, 196, 0.2);\n  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  height: 395px;\n}\n\n.ms-n5 {\n  margin-left: -49px;\n  margin-top: 6px;\n}\n\n.searchBtn {\n  height: 50px;\n  background-color: #ECEFF9 !important;\n  border-radius: 8px !important;\n  height: 2.8rem;\n}\n\n.Btn {\n  width: 22rem !important;\n}\n\n.sortBtn {\n  width: 10rem !important;\n  border: 2px;\n}\n\n.chat {\n  background-color: #e6e6e6;\n  border-radius: 40px 10px 10px 10px;\n}\n\n.user-img {\n  height: 70px;\n  width: 70px;\n}\n\n.chatBox {\n  height: 60rem;\n}\n\n.avatar img {\n  border-radius: 50%;\n  position: relative;\n  left: -5px;\n  margin-left: -15px;\n  z-index: 1;\n}\n\n.imgSize {\n  height: 30px;\n  width: 30px;\n}\n\n.avatars {\n  direction: rtl;\n  padding-left: 25px;\n  /* Same value as the negative margin */\n}\n\n._1EEDX:focus {\n  outline: none !important;\n  border: none !important;\n}\n\n._3sXmF:hover {\n  background: none !important;\n}\n\n.selectedType>div>div {\n  padding: 0px;\n}\n\n/* fieldset{\n  border: none !important;\n} */\n.form-input input {\n  display: none;\n}\n\n.form-input label {\n  display: block;\n  cursor: pointer;\n}\n\n.cursorGrab {\n  cursor: grab;\n}\n\n.imageOpacity {\n  opacity: 1;\n  transition: .5s ease;\n  backface-visibility: hidden;\n}\n\n.containerImage:hover .imageOpacity {\n  opacity: 0.3;\n}\n\n.h-55vh {\n  height: 55vh;\n}\n\n.apply {\n  right: 7px;\n  ;\n}\n\n.content-wrapper {\n  height: 96vh;\n  width: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n\n.active {\n  color: var(--red);\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n\n/* CSS added on -> 24-11-2022:Vibhav */\n\n/* Define new buttons styles */\n.gn-actionbtn-color {\n  color: #F14950 !important;\n}\n\n.gn-actionbtn-outline {\n  border: 1px solid #F14950 !important;\n  border-radius: 10px !important;\n}\n\n.gn-actionbtn {\n  background-color: #F14950 !important;\n  border: 1px solid #F14950 !important;\n  border-radius: 10px !important;\n  box-sizing: border-box;\n  padding: 10px;\n  gap: 10px;\n  color: #fff !important;\n  box-shadow: 0px 4px 8px -4px #4C4E646B;\n}\n\n.disablebtn {\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 10px 24px;\n  color: #b9b9b9;\n  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */\n\n}\n\n.gn-actionbtn:hover {\n  transition: all 0.2s ease-in;\n  scale: 1.05;\n}\n\n.gn-actionbtn.outlined,\n.gn-actionbtnsq.outlined {\n  background-color: transparent;\n  color: #E41116\n}\n\n.gn-actionbtn.outlined.dark,\n.gn-actionbtnsq.outlined.dark {\n  background-color: transparent;\n  color: #161513;\n  border-color: #161513;\n  font-weight: 500;\n}\n\n.gn-actionbtnsq {\n  padding: 6.5px;\n  border-radius: 4px;\n  border: 1px solid #E41116;\n}\n\n.gn-actionbtncircle {\n  width: 2.5rem !important;\n  height: 2.5rem !important;\n  border-radius: 50% !important;\n  box-shadow: 0px 0px 10px 2px #00000045;\n  border: solid 1px var(--red);\n}\n\n.gn-actionbtncircle.solid {\n  color: var(--white);\n  background-color: var(--red);\n}\n\n.gn-actionbtncircle.outlined {\n  color: var(--red);\n  background-color: var(--white);\n}\n\n.icononly-btn {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0px;\n  margin: 0px;\n  border: none;\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  text-align: center;\n  cursor: pointer;\n  display: block;\n  background: none;\n  appearance: none;\n  box-sizing: border-box;\n  vertical-align: middle;\n}\n\n.gn-btn-icononly {\n  background: transparent;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  border: none;\n}\n\n/*To hide the clear icon in mui component autocomplete select component language page*/\n.css-1q60rmi-MuiAutocomplete-endAdornment {\n  display: none;\n}\n\n/* Override the link css */\na {\n  color: #2979BC\n}\n\na:hover {\n  color: #2979BC\n}\n\na.nav-list-items {\n  text-decoration: none;\n}\n\n/* Override bootstrap css to make links responsive:06-12-2022 */\n@media only screen and (max-width: 1280px) and (min-width: 1100px) {\n  .creator-links.col-xl-5 {\n    width: 60% !important;\n  }\n}\n\n@media (max-width:500px) {\n\n  .container-fluid.creator-link-panel,\n  .container-fluid.creator-playlist-panel {\n    margin: 0px;\n    padding: 0px\n  }\n\n  .pic-holder {\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  .card-container {\n    padding: 0px !important;\n  }\n\n  .link-details {\n    padding: 10px 0px !important\n  }\n}\n\n/* CSS for new profile design:07-12-2022 */\n.main-profile-container {\n  flex-wrap: wrap\n}\n\n.profile-tabs {\n  width: 20%;\n}\n\n.probile-tab-content {\n  width: 80%\n}\n\n@media only screen and (max-width: 1100px) {\n  .profile-tabs {\n    width: 100%;\n  }\n\n  .probile-tab-content {\n    width: 100%\n  }\n}\n\na button {\n  opacity: 1 !important;\n  font-size: 1.25rem !important;\n  text-transform: capitalize !important;\n}\n\n.account-bg {\n  background: rgba(249, 249, 249, 0.3);\n}\n\n@-moz-document url-prefix() {\n\n  html,\n  .scroll-element .MuiDrawer-paper {\n    overflow-y: scroll;\n    scrollbar-color: #E41116 rgb(231, 229, 229);\n    box-shadow: inset 0 0 5px rgb(231, 229, 229);\n    border-radius: 10px;\n    scrollbar-width: thin;\n  }\n}\n\n/* For Firefox */\n/* Set the scrollbar width */\n\n/*Scroll bar styling*/\n/* html::-webkit-scrollbar,\nbody::-webkit-scrollbar,\n.scroll-element .MuiDrawer-paper */\n::-webkit-scrollbar {\n  -moz-width: 0.3rem;\n  -moz-height: 0.3rem;\n  width: 0.3rem;\n  height: 0.3rem;\n}\n\n/* html::-webkit-scrollbar-track,\nbody::-webkit-scrollbar-track,\n.scroll-element.MuiDrawer-paper */\n::-webkit-scrollbar-track {\n  -moz-box-shadow: inset 0 0 5px grey;\n  -moz-border-radius: 10px;\n  box-shadow: inset 0 0 5px grey;\n  border-radius: 10px;\n}\n\n/* html::-webkit-scrollbar-thumb,\nbody::-webkit-scrollbar-thumb,\n.scroll-element.MuiDrawer-paper */\n::-webkit-scrollbar-thumb {\n  -moz-background-color: #E41116;\n  background-color: #E41116;\n}\n\n\n.element-with-scroll {\n  overflow-y: scroll;\n  max-height: 100px;\n  /* Set a maximum height for the scrollable element */\n}\n\n\n\n/* Styling the scrollbar in Firefox  */\n.element-with-scroll {\n  scrollbar-color: red green;\n  scrollbar-width: thin;\n}\n\n.removeBorder .MuiInputBase-root::before {\n  border-bottom: 0px !important\n}\n\n.gn-actionbtn:disabled {\n  opacity: 0.5;\n}\n\n/* css for the verification page column */\n.verifyCol1 {\n  width: calc(40% - 20px);\n}\n\n.verifyCol2 {\n  width: calc(60% - 20px);\n}\n\n#artist-avatar {\n  width: 30%\n}\n\n#artist-status {\n  width: 70%\n}\n\n.column-1 {\n  width: 30%\n}\n\n.column-2 {\n  width: 65%\n}\n\n@media (min-width:1281px) and (max-width:1550px) {\n\n  /* For portrait layouts only */\n  #artist-avatar {\n    width: 35%\n  }\n\n  #artist-status {\n    width: 65%\n  }\n\n  .column-1 {\n    width: 40%\n  }\n\n  .column-2 {\n    width: 55%\n  }\n}\n\n@media (max-width:1280px) {\n  .verifyCol1 {\n    width: 100%\n  }\n\n  .verifyCol2 {\n    width: 100%\n  }\n\n  .column-1 {\n    width: 100% !important\n  }\n\n  .column-2 {\n    width: 100% !important\n  }\n}\n\n@media (max-width:768px) {\n  #artist-avatar {\n    width: 100%\n  }\n\n  #artist-status {\n    width: 100%\n  }\n}\n\n/*switcher styles*/\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 19px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  -webkit-transition: .4s;\n  transition: .4s;\n  box-shadow: inset 0px 4px 4px #00000042;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n  box-shadow: 2px 2px 2px #33333375;\n}\n\ninput:checked+.slider {\n  background-color: #B1C5E7;\n  box-shadow: inset 0px 4px 4px #96a9cb;\n}\n\ninput:disabled+.slider {\n  background-color: none;\n  box-shadow: inset 0px 4px 4px #96a9cb;\n  opacity: 0.4;\n}\n\n/* input:focus + .slider { */\n/*  box-shadow: inset 0 0 1px #B1C5E7; */\n/*  box-shadow: inset 0px 4px 4px #96a9cb; */\n/* } */\n\ninput:checked+.slider:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n/* Css for verification badge */\n.item {\n  position: relative;\n  padding-top: 20px;\n  display: inline-block;\n}\n\n.notify-badge {\n  position: absolute;\n  right: -9px;\n  text-align: center;\n  border-radius: 30px 30px 30px 30px;\n  color: white;\n  padding: 5px 10px;\n  font-size: 20px;\n  bottom: -1px;\n}\n\n/* Design for small screens less than - 768px */\n@media (max-width:1024px) {\n\n  body,\n  body>div,\n  body>p,\n  .link-input-fields div,\n  a button {\n    font-size: 0.8rem !important;\n  }\n\n  /* for button */\n  .gn-actionbtn {\n    padding: 6px 18px !important;\n  }\n\n  .link-wrapper {\n    width: 78% !important\n  }\n\n  .profile-wrapper {\n    width: 22% !important;\n  }\n\n  .switch {\n    width: 26px !important;\n    height: 14px !important;\n  }\n\n  input:checked+.slider:before {\n    left: -2px !important\n  }\n\n  .slider:before {\n    width: 10px !important;\n    height: 10px !important;\n    left: -2px !important;\n    left: 1px !important\n  }\n}\n\n/* .MuiTooltip-popper[data-popper-placement*=\"bottom\"] .css-1k51tf5-MuiTooltip-tooltip {\n  transform-origin: center top;\n  margin-top: 0px !important;\n} */\n/* CSS to override the style of mui buttons */\n/* .iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root,.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root{\n    max-width: 40px !important;\n    min-width: 40px!important;\n    min-height: 40px!important;\n    max-height: 40px!important;\n}\n\n.iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root, .iconBnt-mui.css-1rwt2y5-MuiButtonBase-root-MuiButton-root:hover{border-color:#E41116;color:#E41116}\n.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root,.iconBnt-mui.css-sghohy-MuiButtonBase-root-MuiButton-root:hover{ background-color:#E41116;}\n\n */\n.custom-tooltip {\n  padding: 4px 10px;\n  background: #e41116;\n  font-size: 0.8rem;\n  margin: 0;\n  border-radius: 4px;\n  position: relative;\n  color: white;\n  bottom: -5px;\n  left: 0;\n  max-width: 200px;\n  text-align: center;\n}\n\n.custom-tooltip.auto-width {\n  max-width: 200px !important;\n}\n\n\n.custom-tooltip .top::after {\n  content: \"\";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: transparent transparent #E41116 transparent;\n}\n\n/* format the placeholder text for react edit text fields */\n.link-input-fields ._1EEDX {\n  padding: 5px 0px !important\n}\n\n.link-input-fields ._3qwMT {\n  color: #b1adad;\n  font-weight: 400;\n}\n\n.css-18k588b-MuiAutocomplete-root {\n  padding: 5px 0px !important\n}\n\n/* CSS for social card */\n.social-link-container {\n  padding: 15px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.social-link-container .action-btn-container {\n  margin-right: 0 !important\n}\n\n@media (max-width: 768px) {\n  .social-link-container .link-wrapper {\n    width: 95% !important;\n  }\n\n  .social-link-container .action-btn-container {\n    margin-right: 0 !important\n  }\n}\n\n/* New change */\n\n.avatar-upload {\n  position: relative;\n  max-width: 180px;\n  /* margin: 20px auto; */\n}\n\n.avatar-upload .avatar-edit {\n  position: absolute;\n  /* right: 12px; */\n  /* z-index: 1; */\n  /* top: 10px; */\n  right: 45px;\n  z-index: 1;\n  top: 1px;\n  border-radius: 100%;\n}\n\n.avatar-upload .avatar-edit input {\n  display: none;\n}\n\n.avatar-upload .avatar-edit input+label {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  /* width: 20px;\n  height: 20px; */\n  margin-bottom: 0;\n  border-radius: 100%;\n  background: #FFFFFF;\n  border: 1px solid transparent;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n  font-weight: normal;\n  transition: all 0.2s ease-in-out;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar-upload .avatar-edit input+label:hover {\n  background: #f1f1f1;\n  border-color: #d6d6d6;\n}\n\n/* .avatar-upload .avatar-edit input + label:after {\n  content: \"\\f040\";\n  font-family: 'FontAwesome';\n  color: #757575;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  margin: auto;\n} */\n.avatar-upload .avatar-preview {\n  /* width: 192px;\n  height: 192px; */\n  position: relative;\n  border-radius: 100%;\n  /* border: 6px solid #F8F8F8; */\n  /* box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1); */\n}\n\n.avatar-upload .avatar-preview>div {\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n/*singup thank you page*/\n.fullPage>.fullpage-content {\n  position: absolute;\n  left: calc(100% - 87%);\n  top: calc(100% - 87%);\n  transition: all 0.5s ease-in;\n}\n\n.fullPage .fullpage-inner-content {\n  position: relative;\n  left: 17%;\n  transition: all 0.5s ease-in;\n}\n\n.emailVerification>.fullpage-content {\n  position: absolute;\n  width: 100%;\n  left: 50%;\n  top: 10%;\n  transform: translateX(-50%);\n  transition: all 0.5s ease-in;\n}\n\n.fullpage-logo>img {\n  width: 300px;\n  transition: width 0.5s ease-in;\n}\n\n.fullpage-logo {\n  padding: 0.5rem\n}\n\n@media (max-width:767px) {\n  .fullPage>.fullpage-content {\n    position: absolute;\n    left: 1%;\n    top: 15%;\n    transition: all 0.5s ease-in;\n  }\n\n  .emailVerification>.fullpage-content {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    transition: all 0.5s ease-in;\n  }\n\n  .fullPage .fullpage-inner-content {\n    position: relative;\n    left: 0%;\n    transition: all 0.5s ease-in;\n    padding: 0.5rem;\n  }\n\n  .fullPage>.fullpage-content>img,\n  .emailVerification>.fullpage-content>img {\n    width: 70%;\n    transition: all 0.5s ease-in;\n  }\n\n  .fullpage-logo>img {\n    width: 30%;\n    transition: width 0.5s ease-in;\n  }\n}\n\n@media (min-width:768px) and (max-width:1280px) {\n  .fullPage>.fullpage-content {\n    position: absolute;\n    left: 5%;\n    top: 13%;\n    transition: all 0.5s ease-in;\n  }\n\n  .fullPage .fullpage-inner-content {\n    position: relative;\n    width: 80%;\n    left: 11%;\n    transition: all 0.5s ease-in;\n  }\n\n  .fullPage>.fullpage-content>img {\n    width: 70%;\n    transition: all 0.5s ease-in;\n  }\n\n  .fullpage-logo>img {\n    width: 180px;\n    transition: width 0.5s ease-in;\n  }\n\n}\n\n.pagination {\n  width: 100%;\n}\n\n.tableSelector {\n  color: var(--selectorColor) !important;\n}\n\n.tableSelector.Mui-checked,\n.tableSelector.MuiCheckbox-indeterminate {\n  color: var(--selectedColor) !important;\n}\n\n.MuiTablePagination-displayedRows {\n  /* padding: 14px 0px 10px !important; */\n  margin-top: 14px;\n}\n\n.MuiTablePagination-selectLabel {\n  margin-top: 14px;\n}\n\n/* .css-1jamkpd-MuiToolbar-root {\n    min-height: 10px !important;\n} */\n.css-1fjhhui-MuiToolbar-root {\n  min-height: 10px !important;\n\n\n}\n\n.css-1tw8r9a-MuiToolbar-root {\n  min-height: 10px !important;\n\n}\n\n/* Latest css by tanya for submit a song--- */\n\n/* .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root{\n  height: 1.5em !important;\n  width: 1.5em !important;\n} */\n/* .css-i4bv87-MuiSvgIcon-root{\n  width: 2em !important;\n} */\n\n\n.cardheading {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #222222b5;\n}\n\n.status {\n  border: 1px;\n  border-radius: 15px;\n  padding: 2px 10px;\n  width: fit-content;\n  text-align: center;\n  font-size: 12px;\n}\n\n.audio-uploader {\n  border: 2px dashed rgba(0, 0, 0, 0.5);\n  border-radius: 10px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  width: 100%;\n  background: #EAEAEA;\n  height: 200px;\n  cursor: pointer;\n}\n\n.audio-uploader.custom-height {\n  height: 150px;\n}\n\n.audio-uploader input[type='file'] {\n  display: none;\n}\n\n.audio-uploader .dragInputText {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-left: 0.8rem;\n  padding: 0.6rem 0rem;\n}\n\n.audio-uploader .dropImage {\n  opacity: 0.3;\n}\n\n.songPoster {\n  border-radius: 20px;\n  max-width: 280px;\n  max-height: 280px;\n}\n\n.poster-uploader {\n  text-align: center;\n}\n\n#removeSongPoster {\n  display: flex;\n  justify-content: end;\n}\n\naudio.gn-audioplayer {\n  width: 100%;\n  height: 60px;\n}\n\n.box {\n  width: 60%;\n  max-width: 1024px;\n  margin: 0 auto;\n  /* center the box horizontally */\n  transition: width 0.5s ease-in;\n}\n\n#addsong-stepper-container #songposter-helpertext {\n  padding: 1.2rem 1rem;\n}\n\n.value-pair {\n  padding: 0.4rem 0rem\n}\n\n@media (max-width:500px) {\n  #song-poster-cnt {\n    width: 100%\n  }\n\n  .songPoster {\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%\n  }\n}\n\n@media (min-width:501px) and (max-width:1280px) {\n  #song-poster-cnt {\n    width: 40%\n  }\n\n  .songPoster {\n    max-width: 200px;\n    max-height: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .box {\n    width: 100%;\n  }\n}\n\n/* @media (min-width: 769px) and(max-width:1280px)\n{\n  .songPoster{width: 100%;max-width: 200px;max-height: 200px;}\n  #song-poster-cnt{width:30%}\n} */\n@media (min-width: 769px) and (max-width: 1500px) {\n  .box {\n    width: 90%;\n  }\n}\n\n@media (min-width: 1501px) and (max-width: 1800px) {\n  .box {\n    width: 70%;\n  }\n}\n\n/*End*/\n/* Css by Tanya - responsive card list on mobile */\n/* mobileCard css */\n/* start */\n/* .mobileCard{\n  width: fit-content;\n  text-align: center;\n} */\n.cardLine {\n  line-height: 0.8;\n}\n\n.cardheadingFont {\n  font-size: 0.8rem;\n}\n\n.cardfont {\n  font-size: 0.6rem\n}\n\n.overflow-text {\n  white-space: nowrap;\n  width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.css-78trlr-MuiButtonBase-root-MuiIconButton-root {\n  /* width:1rem; */\n  /* height:1rem; */\n  border-radius: 4px;\n}\n\n.playBtn {\n  /* border: 1px solid #E41116; */\n  border: 1px solid red;\n  border-radius: 4px;\n\n}\n\n.audioBorder {\n  border: 1px solid;\n  border-radius: 5px;\n  width: 100%;\n\n\n}\n\n.boxSize {\n  /* marginLeft:'30%',width:'40%' */\n  margin-left: '30%';\n  width: '40%';\n}\n\n.css-2s90m6-MuiAvatar-root {\n  width: 30px !important;\n  height: 30px !important;\n}\n\n.class-name:after {\n  content: \" \";\n  display: block;\n  border-bottom: 0.5px solid #9E9E9E;\n}\n\n.form-check-input[type=checkbox] {\n  border-radius: 0%;\n}\n\n#imagePreview {\n  width: 200px;\n  /* height: 200px; */\n  height: auto\n}\n\n.truncate-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  /* Optional: Limit the width of the container */\n}\n\n.truncate-text:hover {\n  white-space: normal;\n  overflow: visible;\n}\n\n/* .css-78trlr-MuiButtonBase-root-MuiIconButton-root */\n/* end */\n\n.tempSection {\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  transform: translate(-50%, -50%);\n  top: 50%;\n  left: 50%;\n  text-align: center;\n}\n\n.associatedArtistCardLayout {\n  display: flex;\n  flex-wrap: wrap;\n  /* gap: 10px;  */\n}\n\n@media (max-width: 600px) {\n  .MuiTablePagination-toolbar {\n    padding: 0px !important\n  }\n\n  .smallAssociatedArtistCard {\n    flex: 1 1 calc(50% - 10px);\n    max-width: calc(50% - 10px);\n    /* Reduce the card's max width for small screens */\n    transform: scale(0.8);\n    /* Apply scaling for small screens */\n    transform-origin: left;\n  }\n\n  .cardPagination {\n    font-size: 0.8rem !important\n  }\n\n  .css-16c50h-MuiInputBase-root-MuiTablePagination-select {\n    margin-right: 0.8rem !important\n  }\n}\n\n@media (max-width: 280px) {\n  .smallAssociatedArtistCard {\n    flex: 1 1 100%;\n    /* 1 card per row on devices with a width of 280px or less */\n    max-width: 100%;\n    /* Set the card's max width to 100% for single card layout */\n    transform: none;\n    /* Reset scaling for very small screens */\n  }\n}\n\n.notificationItem:hover {\n  background-color: rgb(247, 246, 246);\n  cursor: pointer;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  background-color: #fff;\n  /* Adjust the background color as needed */\n  z-index: 1000;\n  /* Ensure it's above other content */\n  transition: box-shadow 0.3s ease;\n  /* Add a smooth transition effect for the box shadow */\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n}\n\n.css-6hp17o-MuiList-root-MuiMenu-list {\n  padding-bottom: 0px !important;\n  padding-top: 0px !important;\n}\n\n/* buttonStyles.css */\n\n/* Base button styles */\n.pagination-button {\n  border-radius: 4px;\n  width: 100%;\n  padding: 4px 0px;\n  font-weight: bold;\n}\n\n/* Enabled button styles */\n.pagination-button.enabled {\n  color: red;\n  border: 1px solid #E41116;\n  background-color: #fff;\n}\n\n/* Disabled button styles */\n.pagination-button.disabled {\n  color: gray;\n  border: 1px solid #3A3A3A;\n  background-color: #fff;\n  opacity: 0.5;\n}\n\n.card-container {\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  justify-content: center;\n}\n\n@media (max-width: 599px) {\n  .card-container {\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  }\n}\n\n@media (max-width: 280px) {\n  .card-container {\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  }\n}\n\n.wrapper-card {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr 1fr;\n  grid-gap: 20px;\n  padding: 20px 0;\n}\n\n.box-card {\n  border-radius: 16px;\n  background: #FFF;\n  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.10);\n  border-radius: 3px;\n  padding: 10px;\n  font-size: 14px;\n  max-width: 330px;\n  min-width: 200px;\n}\n\n.card-media {\n  border-radius: 10px;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.28) 63.54%, #000 96.02%), lightgray 50% / cover no-repeat;\n}\n\n.artistDetailStyle {\n  border: 1px solid #ccc;\n  font-size: 14px;\n  border-radius: 20px;\n  background-color: #f0f0f0;\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n  padding-left: 0.8rem;\n  padding-right: 0.8rem;\n  margin-right: 10px;\n  margin-top: 10px;\n  font-weight: 400;\n  text-align: center;\n  display: inline-block;\n}\n\n.css-1c7htm4-MuiList-root.left-margin {\n  margin-left: 10rem;\n}\n\n.titlea {\n  /* width: 90%; */\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  min-width: 100px;\n  line-height: 1.2;\n  margin-bottom: 0px;\n}\n\n.externallinkicon {\n  width: '50px';\n  height: '50px';\n  border-radius: '50%';\n  background: '#E41116';\n  display: 'flex';\n  align-items: 'center';\n  justify-content: 'center';\n  margin-right: '8px';\n}\n\n@media (max-width: 600px) {\n  .mobile-buttons {\n    flex-direction: column;\n    /* Display buttons in a column on mobile screens */\n  }\n}\n\n.demodetailCol2 {\n  width: calc(60% - 20px);\n}\n\n/* ---------------- suman css start ----------- */\n.text-truncate-sm {\n  width: 100px;\n  text-overflow: ellipsis;\n  text-wrap: nowrap;\n  overflow: hidden;\n}\n\n.detailText::first-letter {\n  text-transform: capitalize;\n}\n\n.wordBreak {\n  word-break: break-all;\n}\n\n.color-secondory {\n  color: rgba(0, 0, 0, 0.8);\n  opacity: 90%;\n}\n\n.circle-spinner-container {\n  top: 7px;\n  left: 7.4px;\n}\n\n.fileDragDrop {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.height30vh {\n  height: 30vh;\n}\n\n@media (max-width:330px) {\n  .mediaMusic {\n    flex-direction: column;\n  }\n}\n\n.special-label.special-label::after {\n  content: ' *';\n}\n\n.hide-div {\n  display: none;\n}\n\n.imageRadio span>input {\n  position: relative;\n}\n\n.radioButtonBanner>input {\n  position: absolute;\n  top: 8;\n  right: 8;\n  background-color: 'rgba(255, 255, 255, 0.7)';\n  border-radius: '20px';\n  width: '6%';\n  height: '16%';\n}\n\n.chipStyle {\n  background: linear-gradient(90.67deg, #DF1868 0.64%, #E52D26 49.35%, #F05F21 81.27%, #FACB0C 98.46%);\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  color: #fff !important;\n  font-size: 12px !important;\n  height: 25px !important;\n}\n.blurred-disabled {\n  /* filter: blur(2px); */\n  pointer-events: none;\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
